import { cn } from "@/lib/utils";

type Tone = "neutral" | "success" | "warn" | "danger" | "info";

const toneClasses: Record<Tone, string> = {
  neutral: "bg-muted text-muted-foreground border-border",
  success: "bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30",
  warn: "bg-yellow-500/15 text-yellow-700 dark:text-yellow-300 border-yellow-500/30",
  danger: "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/30",
  info: "bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/30",
};

interface Props {
  label: string;
  tone?: Tone;
  className?: string;
}

const StatusBadge = ({ label, tone = "neutral", className }: Props) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-medium uppercase tracking-wider",
      toneClasses[tone],
      className
    )}
  >
    {label}
  </span>
);

export const emailStatusTone = (status: string): Tone => {
  switch (status) {
    case "sent":
      return "success";
    case "pending":
      return "info";
    case "suppressed":
      return "warn";
    case "dlq":
    case "failed":
    case "bounced":
    case "complained":
      return "danger";
    default:
      return "neutral";
  }
};

export default StatusBadge;
